import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useProductTour } from "@/hooks/use-product-tour";
import { ProductTourTooltip } from "./ProductTourTooltip";

export function ProductTourOverlay() {
  const { isActive, targetRect, currentStep } = useProductTour();

  if (!isActive || !currentStep) return null;

  const hasTarget = !!targetRect;

  return createPortal(
    <AnimatePresence>
      <motion.div
        key="tour-overlay"
        className="fixed inset-0 z-[9999]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        {/* SVG overlay with spotlight cutout */}
        <svg
          className="absolute inset-0 w-full h-full"
          style={{ pointerEvents: "none" }}
        >
          <defs>
            <mask id="tour-spotlight-mask">
              {/* White = visible (dark overlay) */}
              <rect x="0" y="0" width="100%" height="100%" fill="white" />
              {/* Black = transparent (spotlight hole) */}
              {hasTarget && (
                <motion.rect
                  fill="black"
                  rx={12}
                  ry={12}
                  initial={{
                    x: targetRect.x,
                    y: targetRect.y,
                    width: targetRect.width,
                    height: targetRect.height,
                  }}
                  animate={{
                    x: targetRect.x,
                    y: targetRect.y,
                    width: targetRect.width,
                    height: targetRect.height,
                  }}
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                />
              )}
            </mask>
          </defs>
          <rect
            x="0"
            y="0"
            width="100%"
            height="100%"
            fill="rgba(0, 0, 0, 0.6)"
            mask="url(#tour-spotlight-mask)"
            style={{ pointerEvents: "none" }}
          />
        </svg>

        {/* Spotlight glow ring */}
        {hasTarget && (
          <motion.div
            className="absolute rounded-xl border-2 border-sidebar-primary/40 shadow-[0_0_20px_4px_hsl(var(--sidebar-primary)/0.15)]"
            initial={{
              left: targetRect.x,
              top: targetRect.y,
              width: targetRect.width,
              height: targetRect.height,
            }}
            animate={{
              left: targetRect.x,
              top: targetRect.y,
              width: targetRect.width,
              height: targetRect.height,
            }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
            style={{ pointerEvents: "none" }}
          />
        )}

        {/* Tooltip */}
        <ProductTourTooltip />
      </motion.div>
    </AnimatePresence>,
    document.body
  );
}
